import { useContext } from 'react';

import { CommonDataContext } from 'client/common/contexts';

export function useCommonData() {
    return useContext(CommonDataContext);
}
